// NOTE: This is a workaround to properly "release" the locks of files being closed client-side
//       This needs to happen here because we don't use the SessionController on the server anymore to keep track of open files, that can be mapped to locks

import * as API from '../API';

const locks: Record<number, number[]> = localStorage.ROWLocks ? JSON.parse(localStorage.ROWLocks) : {};
// @ts-ignore
window.filingCabinetLocks = locks;

let allowedToClose = false;

const setAllowedToClose = (allow: boolean): void => {
    allowedToClose = allow;
};

const areFilesLocked = (): boolean => {
    return locks !== null && Object.keys(locks).length > 0;
};

const isAllowedToClose = (): boolean => {
    return allowedToClose;
};

const addLocks = (fc: number, lockUIDs: number[]): void => {
    if (fc == null) {
        return console.error(`Could not add locks because fc was null`);
    }
    if (lockUIDs == null) {
        return console.error(`Could not add locks for FC ${fc} because lockUIDs was null`);
    }

    locks[fc] = [...(locks[fc] ?? []), ...lockUIDs];
    localStorage.ROWLocks = JSON.stringify(locks);
};
window.addLocks = addLocks; // For razor

const getLocks = (fc: number): number[] => {
    return locks[fc] ?? [];
};

const getAllIDs = (): number[] => {
    let ids: number[] = [];
    for (const lock in locks) {
        ids = ids.concat(locks[lock]);
    }
    return ids;
};

const removeLocks = (fc: number): void => {
    if (getLocks(fc)?.length) {
        void API.locks.releaseLocks(getLocks(fc), false);
    }

    delete locks[fc];
    localStorage.ROWLocks = JSON.stringify(locks);
    allowedToClose = false;
};

const removeAll = (): void => {
    if (getAllIDs()?.length) {
        void API.locks.releaseLocks(getAllIDs(), true);
    }

    for (const lock in locks) {
        delete locks[lock];
    }
    allowedToClose = false;
};

export {
    areFilesLocked,
    setAllowedToClose,
    isAllowedToClose,
    addLocks,
    getLocks,
    removeLocks,
    getAllIDs,
    removeAll,
};
